// src/Pages/ContainerAcceptance.js
import React, { useState, useEffect } from "react";
import { getContainerDetails, acceptContainer } from "../api/containerApi";
import { reportContainerDamaged } from "../api/containerApi";


export default function ContainerAcceptance() {
  const [manual, setManual] = useState(false);
  const [reportMode, setReportMode] = useState(false);

  const [containerNo, setContainerNo] = useState("");
  const [scannedContainerNo, setScannedContainerNo] = useState(""); 
  const [damageStatus, setDamageStatus] = useState("Damaged");


  const [acceptanceID, setAcceptanceID] = useState(null);
  const [asn, setAsn] = useState("");
  const [shipperId, setShipperId] = useState("");
  const [shipperName, setShipperName] = useState("");
  const [weight, setWeight] = useState("");
  const [AcceptedWeight, setAcceptedWeight] = useState("");
  const [weightUom, setWeightUom] = useState("");
  const [dimension, setDimension] = useState("");
  const [dimensionUom, setDimensionUom] = useState("");
  const [shipmentType, setShipmentType] = useState("");
  const [damaged, setDamaged] = useState(0);
  const [orderStatus, setOrderStatus] = useState("Pending");

  const resetForm = () => {
    setAcceptanceID(null);
    setAsn("");
    setShipperId("");
    setShipperName("");
    setWeight("");
    setAcceptedWeight("");
    setWeightUom("");
    setDimension("");
    setDimensionUom("");
    setShipmentType("");
    setOrderStatus("Pending");
  };

  const resetPage = () => {
  resetForm();
  setContainerNo("");
  setScannedContainerNo("");
  setDamageStatus("Damaged");
  setReportMode(false);
  setManual(false);

  
  setTimeout(() => {
    document.getElementById("containerInput")?.focus();
  }, 150);
};


  const fetchDetails = async (cn) => {
    if (!cn) return;

    try {
      const { data } = await getContainerDetails(cn);

      setScannedContainerNo(cn); // ✅ FIX
      setAcceptanceID(data.AcceptanceID);
      setAsn(data.ASNNumber);
      setShipperId(data.ShipperId);
      setShipperName(data.ShipperName);
      setWeight(data.Weight);
      setWeightUom(data.WeightUOM);
      setDimension(`${data.Length} x ${data.Width} x ${data.Height}`);
      setDimensionUom(data.DimUOM);
      setShipmentType(data.Type);
      setOrderStatus(data.Status);

      if (!manual) {
        setTimeout(() => {
          document.getElementById("containerInput")?.focus();
        }, 150);
      }
    } catch {
      alert("Container not found");
      resetForm();
    }
  };

  // 🔹 Auto-fetch for scanner (NO ENTER required)
  useEffect(() => {
    if (manual || !containerNo) return;

    const timer = setTimeout(() => {
      if (containerNo.length > 3) fetchDetails(containerNo);
    }, 150);

    return () => clearTimeout(timer);
  }, [containerNo, manual]);

  // 🔹 Auto-calc Accepted Weight in report mode
  useEffect(() => {
    if (!reportMode) return;

    const recv = Number(weight);
    const dmg = Number(damaged);
    if (isNaN(recv) || isNaN(dmg)) return;

    setAcceptedWeight(Math.max(recv - dmg, 0));
  }, [damaged, weight, reportMode]);

const handleAccept = async () => {
  if (!acceptanceID) return alert("Scan container first");

  const accWt = Number(AcceptedWeight);
  //if (!accWt || accWt > Number(weight))
  if (!accWt)
    return alert("Invalid Accepted Weight");

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;

  if (!userId) {
    alert("User not logged in");
    return;
  }

  try {
    await acceptContainer(acceptanceID, accWt, userId);
    alert("Shipment Accepted");
    setOrderStatus("Accepted");
    setAcceptedWeight("");
    resetPage();
  } catch {
    alert("Accept failed");
  }
};

const handleReport = async () => {
  if (!asn) {
    alert("Scan container first");
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;

  if (!userId) {
    alert("User not logged in");
    return;
  }

  const payload = {
    asnNumber: asn,
    containerNumber: scannedContainerNo,
    status: damageStatus,
    userId,
    acceptedWeight: AcceptedWeight || 0
  };

  try {
    await reportContainerDamaged(payload);
    alert("Container damage reported");
    resetPage();
    setOrderStatus(damageStatus);
    setDamaged(0);
    setReportMode(false);
  } catch (err) {
    console.error("Damage report failed:", err);
    alert("Damage report failed");
  }
};


  return (
    <div className="page">
      <h2 className="title">Container Acceptance</h2>

      <div className="card">
        <div className="row">
          <label>
            <input
              type="checkbox"
              checked={manual}
              onChange={() => {
                setManual(!manual);
                resetForm();
              }}
            />{" "}
            Manual Entry
          </label>

          <label>
            <input
              type="checkbox"
              checked={reportMode}
              onChange={() => {
                setReportMode(!reportMode);
                setDamaged(0);
                setAcceptedWeight("");
              }}
            />{" "}
            Report Damaged 
          </label>
        </div>

        <div className="input-group">
          <label>Container Number</label>
          <input
            id="containerInput"
            value={containerNo}
            onChange={(e) => setContainerNo(e.target.value)}
            placeholder={manual ? "Enter Container No" : "Scan Container"}
            autoFocus
          />
        </div>

        {manual && (
          <button className="btn secondary" onClick={() => fetchDetails(containerNo)}>
            Load Details
          </button>
        )}

        <div className="input-group"><label>ASN</label><input value={asn} readOnly /></div>
        <div className="input-group"><label>Shipper ID</label><input value={shipperId} readOnly /></div>
        <div className="input-group"><label>Shipper Name</label><input value={shipperName} readOnly /></div>
        <div className="input-group"><label>Received Weight</label><input value={weight} readOnly /></div>

        <div className="input-group">
          <label>Accepted Weight</label>
          <input
            type="number"
            value={AcceptedWeight}
            readOnly={reportMode}
            onChange={(e) => setAcceptedWeight(e.target.value)}
          />
        </div>

        <div className="input-group"><label>Weight UOM</label><input value={weightUom} readOnly /></div>
        <div className="input-group"><label>Dimension</label><input value={dimension} readOnly /></div>
        <div className="input-group"><label>Dimension UOM</label><input value={dimensionUom} readOnly /></div>
        <div className="input-group"><label>Shipment Type</label><input value={shipmentType} readOnly /></div>

        {reportMode && (
          <div className="input-group">
          <label>Order Status</label>
            <select
                className="order-status-select"
                value={damageStatus}
                onChange={(e) => setDamageStatus(e.target.value)}
              >
                <option value="Damaged">Damaged</option>
                <option value="Short-Received">Short-Received</option>
              </select>           
          </div>
        
        )}
        <div className="btn-row">
          {reportMode ? (
            <button className="btn secondary" onClick={handleReport}>
              Report
            </button>
          ) : (
            <button className="btn primary" onClick={handleAccept}>
              Accept
            </button>
          )}
        </div>
      </div>

      <style>{styles}</style>
    </div>
  );
}
const styles = `
.page { padding: 15px; background: #f5f6fb; min-height: 100vh; }
.title { text-align: center; font-size: 24px; margin-bottom: 12px; color: #E30016; }
.card { background: #fff; padding: 20px; border-radius: 12px;
        max-width: 480px; margin: auto; box-shadow: 0 2px 6px rgba(0,0,0,0.1); }
.row { margin-bottom: 12px; display: flex; flex-direction: column; gap: 8px; }
.input-group { margin-bottom: 12px;width:95%; }
.input-group input { width: 95%; padding: 8px; border-radius: 6px; border: 1px solid #888; }
.order-status-select {
  width: 95%;
  height: 44px;
  padding: 10px;
  font-size: 15px;
  border-radius: 6px;
  border: 1px solid #888;
  background-color: #fff;
}
.btn-row { display: flex; justify-content: space-between; }
.btn { padding: 10px 16px; border-radius: 8px; font-weight: bold;
       cursor: pointer; border: none; color: #fff; }
.primary { background: #E30016; }
.secondary { background: gray; }
`;
